var _line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStepper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 4,
    viewBox: "0 0 56 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.5,
    y1: 2,
    x2: 54.5,
    y2: 2,
    stroke: "#677B99",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeDasharray: "1 8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepper);
export default __webpack_public_path__ + "static/media/stepper.3db13dc8cf20243d686a4d06d5f733a9.svg";
export { ForwardRef as ReactComponent };